import React, { useState } from 'react';
import lbnlogo from '../Images/lbnlogo.jpeg';
import axios from 'axios'
import './Navbar.css';
import { Link, useNavigate } from 'react-router-dom'; // Updated import

const Navbar = ({ isAuthenticated, setIsAuthenticated }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [otp, setOtp] = useState('');

   
  const navigate = useNavigate(); // Use useNavigate for navigation

  const openModal = () => {
    setModalOpen(true);
    setOtpSent(false);
    setInputValue('');
    setOtp('');
  };

  const closeModal = () => {
    setModalOpen(false);
    setOtpSent(false);
    setInputValue('');
    setOtp('');
  };

  const handleLogin = async () => {
    if (inputValue.trim() !== '') {
      try {
        // Send OTP Request to the backend API
        const response = await axios.post('https://api.lbnhyderabad.com/auth-mp/sendOtp', {
          inputValue
        });
        if (response.data.success) {
          setOtpSent(true);
        }
      } catch (error) {
        alert("Error sending OTP!");
      }
    } else {
      alert('Please enter your email or WhatsApp number');
    }
  };

  const handleVerifyOtp = async () => {
    if (otp.trim() !== '') {
      try {
        // Verify OTP request
        const response = await axios.post('https://api.lbnhyderabad.com/auth-mp/verifyOtp', {
          inputValue,
          otp
        });
        if (response.data.success) {
          // Store the user email/number in localStorage
          localStorage.setItem('user', inputValue);
              setIsAuthenticated(true);  // ✅ update auth state
          alert('OTP Verified Successfully!');
          closeModal();
          navigate('/dashboard');
     
        } else {
          alert('Invalid OTP');
        }
      } catch (error) {
        alert("Error verifying OTP!");
      }
    } else {
      alert('Please enter OTP');
    }
  };

  const handleResend = async () => {
    try {
      const response = await axios.post('https://api.lbnhyderabad.com/auth-mp/sendOtp', {
        inputValue
      });
      if (response.data.success) {
        alert('OTP Resent!');
      }
    } catch (error) {
      alert("Error resending OTP!");
    }
  };

  return (
    <>
      <nav className="navbar">
        <div className="logo">
          <img src={lbnlogo} alt="LBN Market Place Logo" className="logo-img" />
          <h1 className="market-text">Market Place</h1>
        </div>

        <ul className="nav-links">
          <li><a href="/">Home</a></li>
          <li><a href="/products">Products</a></li>
          <li><a href="/contact">Contact</a></li>
          {isAuthenticated ? (
              <Link to="/dashboard">
  <i className="fas fa-user-circle" style={{ fontSize: '20px', color:'#fff' }}></i>
</Link>
            ) : (
              <button className="login-btn" onClick={openModal}>Login</button>
            )}
        </ul>
      </nav>

      {modalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>&times;</button>
            <h2 className="modal-title" style={{color:'#faae2f'}}>Welcome Back to LBN</h2>
            <p className="modal-slogan">Connect instantly with verified dealers. Login to unlock exclusive offers!</p>

            {!otpSent ? (
  <>
    <input
      type="text"
      placeholder="Email or WhatsApp Number"
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      className="modal-input"
    />
    <button className="modal-login-btn" onClick={handleLogin}>
      Send OTP
    </button>
  </>
) : (
  <>
    <input
      type="text"
      placeholder="Enter OTP"
      value={otp}
      onChange={(e) => setOtp(e.target.value)}
      className="modal-input"
    />
    <button className="modal-login-btn" onClick={handleVerifyOtp}>
      Verify OTP
    </button>
    <button className="modal-resend-btn" onClick={handleResend}>
      Resend OTP
    </button>
  </>
)}


          
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;